import { GreenhouseIcon } from './GreenhouseIcon';

/**
 * author: Jeff Anders
 * id 9AE6BA3C-694B-47D5-99C3-7D063228F053
 * name greenhouse
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/greenhouse.svg
 * tags
 * - Home Automation 
 * - Agriculture 
 * - Nature 
 */
export const GlasshouseIcon = GreenhouseIcon;
export default GlasshouseIcon